export default __webpack_public_path__ + "static/media/phapoom_v1.f049c22c.webp";